import MonitoringAlertItem from './monitoring-alert-item';

export default MonitoringAlertItem;